import { IReturnInventoryInput } from '@shared/types/return_inventory_input';

interface IBuildReturnInventoryInputProps {
  items: Array<{ id: string | number }>;
}

export const buildReturnInventoryInput = ({ items }: IBuildReturnInventoryInputProps): IReturnInventoryInput => ({
  itemIDs: items.map(({ id }) => String(id)),
});
